import { AppState, createInitialState } from "./AppState";

type Listener = (state: AppState) => void;

class StateStore {
  private state: AppState;
  private listeners: Set<Listener> = new Set();

  constructor() {
    this.state = createInitialState();
  }

  get(): AppState {
    return this.state;
  }

  set(partial: Partial<AppState>): void {
    this.state = { ...this.state, ...partial };
    this.notify();
  }

  reset(): void {
    const highScore = this.state.highScore;
    const sharesUsed = this.state.sharesUsed;
    this.state = createInitialState();
    this.state.highScore = highScore;
    this.state.sharesUsed = sharesUsed;
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener(this.state);
    }
  }
}

export const store = new StateStore();
